import { Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { CheckSingleIcon } from '~/images/icons';
import CandidateSearchIcon from '~/images/perm/candidate-search-icon.svg';

export const PermanentJobsTips = () => {
  return (
    <Column p={8} className="bg-secondary-50 rounded-lg">
      <Typography as="span" bold color={colors.primary[500]} size="body_large">
        Start Receiving Qualified Candidates Today
      </Typography>
      <Column gap={4} className="mt-4 mb-6">
        <Row gap={1}>
          <CheckSingleIcon color={colors.secondary[500]} />
          <Column>
            <Typography as="span">
              <Typography as="span" bold>Pre-screened, qualified applicants</Typography> from GoTu’s vetted dental
              network.
            </Typography>
          </Column>
        </Row>

        <Row gap={1}>
          <CheckSingleIcon color={colors.secondary[500]} />
          <Column>
            <Typography as="span">
              <Typography as="span" bold>Facilitated onsite interviews</Typography> show you how candidates perform before
              you make a hire.
            </Typography>
          </Column>
        </Row>

        <Row gap={1}>
          <CheckSingleIcon color={colors.secondary[500]} />
          <Column>
            <Typography as="span">
              <Typography as="span" bold>Your job stays live for 30 days with auto-renewal</Typography>, keeping you top
              of mind.
            </Typography>
          </Column>
        </Row>
      </Column>
      <Row
        align="center"
        gap={4}
        py={4}
        px={3}
        className="rounded-lg"
        style={{ backgroundColor: '#D1EDF2' }}
      >
        <img src={CandidateSearchIcon} alt="candidate-search-icon" />
        <Column>
          <Typography as="span" bold color={colors.primary[500]} size="body_large">
            The GoTu Difference
          </Typography>
          <Typography as="span">
            Less searching, better choices, build a stronger, more reliable team from day one with
            GoTu.
          </Typography>
        </Column>
      </Row>
    </Column>
  );
};
